import React ,{useEffect} from 'react';
import AOS from 'aos';
import Demo from '../Components/Pages/iPad/Demo';
import Banner from '../Components/Pages/iPad/Banner';
import Header from '../Components/Shared/Header/Header';
import Features1 from '../Components/Pages/MobileApp/Features';
import Features from '../Components/Pages/Home/Features';
import Innovative from '../Components/Pages/Home/Innovative';
import Jobs from '../Components/Pages/AboutUs/Jobs';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
import FaqApp from '../Components/Shared/FaqApp/FaqApp';
import Slider from '../Components/Shared/LogoSlider/Slider';
import { images } from '../Components/Pages/Home/data';
import Design from '../Components/Pages/AndroidPad/Design';

function Ipad(){
  useEffect(() => {
    AOS.init({
      duration: 800,
      disable: 'mobile',
      once: true,
    });
  }, []);
    return(
        <>
        <Header/>
         <Banner />
         <Demo />
         <Features1 />
        <Innovative />
        <FaqApp />
        <Slider list={images}  styles="nobg-slider"/>
      <Features />
      <Design />
      <Jobs />
      <Start />
      <Footer/>
        </>
    )
};
export default Ipad ;